export const countriesToRemove = [
  'ALGERIA',
  'ANGOLA',
  'BENIN',
  'BOTSWANA',
  'BURKINA FASO',
  'BURUNDI',
  'CAMEROON',
  'CAPE VERDE',
  'CENTRAL AFRICAN REPUBLIC',
  'CHAD',
  'COMOROS',
  'CONGO',
  'CONGO, THE DEMOCRATIC REPUBLIC OF THE',
  'CONGO, REPUBLIC (BRAZZAVILLE)',
  'COTE D’IVOIRE',
  'DJIBOUTI',
  'EGYPT',
  'EQUATORIAL GUINEA',
  'ERITREA',
  'ETHIOPIA',
  'GABON',
  'GAMBIA',
  'GHANA',
  'GUINEA',
  'GUINEA-BISSAU',
  'KENYA',
  'LESOTHO',
  'LIBERIA',
  'DIVOIRE',
  'LIBYAN ARAB JAMAHIRIYA',
  'MADAGASCAR',
  'MALI',
  'MALAWI',
  'MAURITANIA',
  'MAURITIUS',
  'MAYOTTE',
  'MOROCCO',
  'MOZAMBIQUE',
  'NAMIBIA',
  'NIGER',
  'NIGERIA',
  'REUNION ISLAND',
  'RWANDA',
  'SAO TOME AND PRINCIPE',
  'SENEGAL',
  'SEYCHELLES',
  'SIERRA LEONE',
  'SOMALIA',
  'SOUTH AFRICA',
  'SOUTH SUDAN',
  'SUDAN',
  'SWAZILAND',
  'TANZANIA, UNITED REPUBLIC OF',
  'TOGO',
  'TUNISIA',
  'UGANDA',
  'WESTERN SAHARA',
  'ZAMBIA',
  'ZIMBABWE',
];
